import React from "react";
import { local } from "../../internationalization/Localization";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";

export const RegistrationLinkExpiredForm: React.FunctionComponent = () => {
  return (
    <div className="RegistrationLinkExpiredForm">
      <h1 className="App_pageTitle">{local.get("registrationLinkExpiredForm.title")}</h1>
      <ErrorMessage>{local.get("registrationLinkExpiredForm.error")}</ErrorMessage>
    </div>
  );
}
